import styled from '@emotion/styled';
import React from 'react';

import placeholder_url from '../../../placeholder';
import Cta from '../../OC/oc-cta';
import fixTrackVars from '../../helpers/data_track_prop_map';

const ContactCardContainer = styled.div`
  padding: 15px 0;
  border-bottom: 1px solid #b1b1b1;
  display: inline-block;
  width: 100%;
`;

const ImageContainer = styled.div`
  float: left;
  margin-right: 10px;
  width: 60px;

  @media (min-width: 768px) {
    margin-right: 20px;
    width: 90px;
  }

  @media (min-width: 992px) {
    width: 120px;
  }

  img {
    width: auto;
    max-width: 100%;
    height: auto;
  }
`;

const ContactInfoContainer = styled.div`
  overflow: hidden;
  color: ${({ dark }) => (dark ? 'black' : 'white')};

  & p {
    font-size: 13px;
    color: black;
  }

  & a {
    color: ${({ dark }) => (dark ? 'black' : 'white')};
  }

  .contactInfo a {
    color: ${({ dark }) => (dark ? '#d00' : 'inherit')};
  }
`;

const PreHead = styled.span`
  color: #b1b1b1;
  font-size: 12px;
  text-transform: uppercase;
`;

const Heading = styled.h3`
  font-size: 20px;
  font-weight: 700;
  margin: 0 0 3px;
`;

const PostHead = styled.span`
  font-size: 13px;
  font-weight: 400;
  color: #b1b1b1;
  margin-bottom: 10px;
  display: block;
`;

const ContactInfo = styled.div`
  span {
    margin-right: 8px;
    margin-bottom: 3px;
    font-size: 12px;
    display: inline-block;

    .icon {
      margin-right: 5px;
      font-size: 18px;
      color: #999;
      vertical-align: middle;
    }
  }
`;

export const ActionLink = styled.a`
  font-size: 14px;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }

  .icon {
    margin-right: 8px;
    margin-bottom: -3px;
  }
`;

const ContactCard = ({
  img,
  placeholder,
  url,
  preHead,
  heading,
  name,
  trackType,
  description,
  contactText,
  postHead,
  linkedIn,
  phone,
  mobilePhone,
  email,
  fax,
  track,
  dark = false,
}) => {
  const color = dark ? 'black' : 'white';

  const fixedTrackProps = trackObj => {
    const result = fixTrackVars(trackObj);
    return result || {}; // fallback to empty object if null
  };

  const ctaTrack = {
    track: 'find-a-professional',
    professional: trackType,
    'professional-name': name,
  };

  const methodTrack = {
    'professional-type': trackType,
    'professional-name': name,
  };

  return (
    <ContactCardContainer className="js-matchHeight">
      <ImageContainer>{img && <img src={img || (placeholder && placeholder_url(340, 190))} alt="" />}</ImageContainer>

      <ContactInfoContainer dark={dark}>
        {preHead && <PreHead>{preHead}</PreHead>}
        {url ? (
          <a href={url}>
            <Heading>{heading}</Heading>
          </a>
        ) : (
          <Heading>{heading}</Heading>
        )}
        {postHead && <PostHead dangerouslySetInnerHTML={{ __html: postHead.replace(/\n/g, '<br>') }} />}
        {description && <p>{description}</p>}

        <ContactInfo className="contactInfo">
          {phone && (
            <span>
              <ActionLink href={`tel:${phone}`} {...fixedTrackProps({ track: 'phone', ...methodTrack })}>
                <i className="fa fa-phone icon" />
                {phone}
              </ActionLink>
            </span>
          )}
          {mobilePhone && (
            <span>
              <ActionLink href={`tel:${mobilePhone}`} {...fixedTrackProps({ track: 'phone', ...methodTrack })}>
                <i className="fa fa-phone icon" />
                {mobilePhone}
              </ActionLink>
            </span>
          )}
          {email && (
            <span>
              <ActionLink href={`mailto:${email}`} {...fixedTrackProps({ track: 'email', ...methodTrack })}>
                <i className="fa fa-envelope icon" />
                {email}
              </ActionLink>
            </span>
          )}
          {fax && (
            <span>
              <i className="fa fa-fax icon" />
              {fax}
            </span>
          )}
          {linkedIn && (
            <span>
              <i className="fa fa-linkedin-square icon" />
              <a
                href={linkedIn}
                target="_blank"
                rel="noopener noreferrer"
                data-track="linkedin"
                data-track-professional-type={trackType}
                data-track-professional-name={name}
              >
                {name}
              </a>
            </span>
          )}
        </ContactInfo>

        {url && (
          <Cta
            url={url}
            track={ctaTrack}
            type="secondary"
            chevron="right"
            text={contactText}
            color={color}
            size="small"
            extraClasses="mtm"
          />
        )}
      </ContactInfoContainer>
    </ContactCardContainer>
  );
};

export default ContactCard;
